import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  UrlTree,
} from '@angular/router';

import { Observable, catchError, map, of } from 'rxjs';

import { EventsApiService } from '../../api';
import { isEventActionAllowed } from '../utils/event-action.util';

export const eventEditableGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): Observable<boolean | UrlTree> => {
  const api = inject(EventsApiService);
  const router = inject(Router);
  const eventId = route.paramMap.get('id');

  if (!eventId) {
    return of(router.createUrlTree(['/events']));
  }

  return api.eventControllerGet(eventId).pipe(
    map((event) =>
      isEventActionAllowed('edit', event, true)
        ? true
        : router.createUrlTree(['/events', eventId, 'manage']),
    ),
    catchError(() => of(router.createUrlTree(['/events']))),
  );
};
